export const SearchMessageChannels = {
    Search: "Search",
    PersonalizedEvents: "PersonalizedEvents"
};
//# sourceMappingURL=index.js.map